import React from 'react';
import { Container, Row, Col, Button } from 'shared-portal-component';

import AppModal from '@/components/common/AppModal/AppModal';

export interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  title: string | React.ReactNode;
  paragraphs: Array<string | React.ReactNode>;
  onConfirm: () => void;
  confirmText?: string;
  size?: 'sm' | 'md' | 'lg';
  confirmDisabled?: boolean;
  footerSlot?: React.ReactNode;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  title,
  paragraphs,
  onConfirm,
  confirmText = 'Confirm',
  size = 'lg',
  confirmDisabled = false,
  footerSlot,
}) => {
  if (!open) return null;

  return (
    <AppModal onClose={onClose} title={title} size={size}>
      <Container fluid className="py-2">
        <Row spacing="md">
          <Col size={12} className="pb-6">
            {paragraphs.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex} className="mb-4">
                {paragraph}
              </p>
            ))}
            {footerSlot}
          </Col>
        </Row>

        <Row spacing="none" justify="center" className="pt-4">
          <Col size="content" className="pb-2">
            <Button
              variant="primary"
              size="md"
              onClick={onConfirm}
              disabled={confirmDisabled}
              aria-label={typeof confirmText === 'string' ? confirmText : 'Confirm'}
              text={confirmText}
            />
          </Col>
        </Row>
      </Container>
    </AppModal>
  );
};

export default ConfirmModal;
